import {
  ComponentService,
  DataTransmissionService,
  DbCommonColumnName,
  KeyUsedByItem,
  MessageService,
  ResponseDataModel,
  ShowDefaultDialogService,
  ValidateCheckUtility,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';

export namespace ReceiptDateUtility {
  /**
   * 発注書データに紐づく受領日リストを取得する
   * @param orderSheetTicketKey 発注書のチケットキー
   * @returns 受領日リスト
   */
  export function fetchReceiptDateListByLinkOrderSheet(orderSheetTicketKey: string): Promise<any[]> {
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    const condition = {
      [DbCommonColumnName.TICKET_TYPE]: 'OrderSheet',
      [DbCommonColumnName.TICKET_KEY]: orderSheetTicketKey,
    };

    return new Promise<any[]>((resolve, reject) => {
      try {
        // 指定したレコードを取得する
        const callBack = (response: ResponseDataModel) => {
          if (!response.isCompleted) {
            resolve([]);
          }

          if (
            ValidateCheckUtility.isEmpty(response.data) ||
            ValidateCheckUtility.isEmpty(response.data[KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME])
          ) {
            resolve([]);
          }
          const subTickets = response.data[KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME];

          if (Array.isArray(subTickets['ReceiptDate'])) {
            resolve(subTickets['ReceiptDate'] as any[]);
            return;
          }

          resolve([]);
        };
        dtService.fetchRecord(ViewType.Edit, 'OrderSheet', condition, callBack, false, null);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * 発注書のデータ内で、受領日の番組情報更新に必要なカラム名を定義する
   */
  export const ProgramInfoColumnNameListInOrderSheet = [
    'MProgramTicketKey',
    'MProgramProgramName',
    'MProgramOrderTicketKey',
    'OrderContent',
  ];
  /**
   * 発注書に紐づく受領日リストに対して、番組、発注情報を更新する
   * @param orderSheet 更新対象の発注書データ　（紐づく受領日リストを更新）
   * @returns 処理が完了したことを通知するPromise
   */
  export async function updateProgramInfoAsync(orderSheet: any): Promise<void> {
    /**
     * データの整合性を確認
     * @returns
     */
    const dataIsOK = () => {
      if (ValidateCheckUtility.isEmpty(orderSheet)) {
        return false;
      }
      if (ValidateCheckUtility.isEmpty(orderSheet[DbCommonColumnName.TICKET_KEY])) {
        return false;
      }

      // 受領日リストが存在しない場合は処理を終了
      for (let columnName of ProgramInfoColumnNameListInOrderSheet) {
        if (columnName in orderSheet == false) {
          return false;
        }
      }

      if (KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME in orderSheet) {
        delete orderSheet[KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME];
      }
      return true;
    };

    /**
     * 受領日データを更新する
     * @param receiptDate
     * @param orderSheet
     */
    const updateReceiptDate = async (receiptDate: any, orderSheet: any): Promise<void> => {
      const removeColumnNameList = [
        KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME,
        'GSI_ReceiptDate_Status',
        'Baseticket',
        'TableName',
        'DisplayLabel',
        'LsiKey',
      ];
      receiptDate['MProgramTicketKey'] = orderSheet['MProgramTicketKey'];
      receiptDate['ProgramName'] = orderSheet['MProgramProgramName'];
      receiptDate['MProgramOrderTicketKey'] = orderSheet['MProgramOrderTicketKey'];
      receiptDate['OrderContent'] = orderSheet['OrderContent'];

      // NOTE: 更新処理であることを示すため、履歴情報を追加する 値はバックエンドで変更されるため、ここでは固定値を設定する
      receiptDate[DbCommonColumnName.HISTORY] = {};
      receiptDate[DbCommonColumnName.HISTORY][DbCommonColumnName.CREATE_USER_ID] = 'system';

      removeColumnNameList.forEach((columnName) => {
        if (columnName in receiptDate) {
          delete receiptDate[columnName];
        }
      });

      return new Promise<void>((resolve, reject) => {
        let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
        let dtService = new DataTransmissionService(componentService);

        const callBack = (result: ResponseDataModel) => {
          if (!result.isCompleted) {
            reject(result);
            return;
          }
          resolve();
        };
        dtService.registerRecord(ViewType.Edit, 'ReceiptDate', receiptDate, callBack, null, false);
      });
    };

    if (!dataIsOK()) {
      return Promise.resolve();
    }

    // 更新対象のデータを取得
    const orderSheetTicketKey = orderSheet[DbCommonColumnName.TICKET_KEY];
    const receiptDateList = await fetchReceiptDateListByLinkOrderSheet(orderSheetTicketKey);
    if (receiptDateList.length === 0) {
      return Promise.resolve();
    }

    // データを更新する (非同期処理をスタックする)
    let updatePromiseList: Promise<void>[] = [];
    receiptDateList.forEach((receiptDate) => {
      updatePromiseList.push(updateReceiptDate(receiptDate, orderSheet));
    });

    // 非同期処理の実行結果が全て完了したら、処理を終了する
    Promise.all(updatePromiseList).then(() => {
      updatePromiseList.forEach((promise) => {
        promise.catch((error) => {
          throw error;
        });
      });

      return Promise.resolve();
    });
    return;
  }
}
